import { createStyles, makeStyles } from '@material-ui/core/styles';
import { INFO_BLUE } from 'constants/colors';
export default makeStyles(theme => createStyles({
  active: {
    textDecoration: 'underline'
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  col: {
    display: 'flex',
    flexDirection: 'column'
  },
  colRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end'
  },
  statusStyle: {
    color: INFO_BLUE,
    fontStyle: 'italic'
  },
  tab: {
    color: theme.palette.primary.main
  },
  button: {
    width: '9rem'
  },
  // width 100% to align "pay now" and "see details" buttons' end icons
  buttonText: {
    width: '100%'
  }
}));